import { render, staticRenderFns } from "./JobTable.vue?vue&type=template&id=25be96a5&scoped=true&"
import script from "./JobTable.vue?vue&type=script&lang=js&"
export * from "./JobTable.vue?vue&type=script&lang=js&"
import style0 from "./JobTable.vue?vue&type=style&index=0&id=25be96a5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25be96a5",
  null
  
)

export default component.exports